import { render, staticRenderFns } from "./MlbStageGames.vue?vue&type=template&id=422dc89e&scoped=true&"
import script from "./MlbStageGames.vue?vue&type=script&lang=js&"
export * from "./MlbStageGames.vue?vue&type=script&lang=js&"
import style0 from "./MlbStageGames.vue?vue&type=style&index=0&id=422dc89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422dc89e",
  null
  
)

export default component.exports